// extracted by mini-css-extract-plugin
export default {"mCard":"Gz-z","image":"Hz-z","imageNoBackground":"Iz-z","imageHasCategory":"Jz-z","fullWidth":"Kz-z"};